export default __webpack_public_path__ + "static/media/trashBlack.bc6ad06f.svg";